import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Input } from 'antd';
import FormItem from '@/components/ui/FormItem';

interface OperatorEvaluatedProps {
	onValueChange: (changed: boolean) => void;
}

export const OperatorEvaluated: React.FC<OperatorEvaluatedProps> = ({ onValueChange }) => {
	return (
		<Col xs={24} sm={12}>
			<FormItem labelCol={{ span: 24 }} name={['operator_evaluated']} label="Operator evaluated">
				<Input
					size="large"
					placeholder={I18n.get('Operator evaluated')}
					onChange={() => onValueChange(true)}
				/>
			</FormItem>
		</Col>
	);
};
